<script setup lang="ts">
import { useRoute } from 'vue-router';
import AppShell from './layouts/AppShell.vue';
import UiConfirmHost from './ui/UiConfirmHost.vue';
import UiToasts from './ui/UiToasts.vue';

const route = useRoute();
</script>

<template>
  <RouterView v-if="route.meta.bare" />
  <AppShell v-else-if="route.name">
    <RouterView v-slot="{ Component }">
      <Transition name="page" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
  </AppShell>
  <UiToasts />
  <UiConfirmHost />
</template>

<style>
.page-enter-active {
  transition:
    opacity 160ms var(--ease),
    transform 160ms var(--ease);
}
.page-enter-from {
  opacity: 0;
  transform: translateY(4px);
}
</style>
